import DialogVue from './dialog.vue'

const DialogBox = {}

DialogBox.install = function (Vue, option) {
  const DialogInstance = Vue.extend(DialogVue)

  let curContent

  const initInstance = () => {
    curContent = new DialogInstance()
    const dialogEl = curContent.$mount().$el
    document.body.appendChild(dialogEl)
  }
  Vue.prototype.$dialogBox = {
    showDialogBox (options) {
      if (!curContent) {
        initInstance()
      }
      if (typeof options === 'object') {
        Object.assign(curContent, options)
      }
      return curContent.showModel()
        .then((val) => {
          curContent = null
          return Promise.resolve(val)
        })
        .catch((err) => {
          curContent = null
          return Promise.reject(err)
        })
    }
  }
}

export default DialogBox



// WEBPACK FOOTER //
// ./src/components/model_dialog/index.js